import { graphql, useStaticQuery } from "gatsby"

import type { SeoQuery } from "~types/gatsby"

// Fetches site data from gatsby.
export function useSiteMetadata() {
    return useStaticQuery<SeoQuery>(graphql`
        query SEO {
            site {
                siteMetadata {
                    defaultTitle: title
                    defaultImage: image
                    defaultDescription: description
                    siteUrl
                    titleTemplate
                    twitterUsername
                }
            }
        }
    `)
}
